import { useMemo } from 'react';
import useRouterData from './useRouterData';
import useClaimData from './useClaimData';
import { useValidator } from './useValidator';

// TODO: Type me
export interface FooterProps {
    text: string;
    headerSwitch: string;
    onClick: VoidFunction;
}

export const useRouteProps = (): FooterProps => {
    const { validateClaimNumber } = useValidator();
    const router = useRouterData();
    const claim = useClaimData();

    return useMemo(() => {
        switch (router.location.pathname) {
            case '/':
                return {
                    text: 'continue',
                    headerSwitch: "Let's start with the basics.",
                    onClick: validateClaimNumber,
                };
            case '/asset':
                return {
                    text: 'continue',
                    headerSwitch:
                        claim.claimInfoLinkList.filter((link) => !!link.streetAddress).length > 0
                            ? 'Select your property.'
                            : 'Select your vehicle.',
                    onClick: () => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        window.location.href = claim.claimInfoLinkList[claim.selectedClaimInfoIndex].link;
                    },
                };
            default:
                return {
                    text: 'continue',
                    headerSwitch: "Let's start with the basics.",
                    onClick: () => undefined,
                };
        }
    }, [
        router.location.pathname,
        claim.zipCode.length,
        claim.claimNumber.length,
        claim.selectedClaimInfoIndex,
        claim.claimInfoLinkList,
        validateClaimNumber,
    ]);
};
